const optimizely = require('@optimizely/optimizely-sdk');

export let optimizelyClient;

export const initOptimizely = () => {
  optimizelyClient = optimizely.createInstance({
    sdkKey: window.optimizelyKey,
  });
};
